import React, { useCallback, useMemo, useState } from 'react'

import UserWishlistInformationItem from '../UserWishlistInformationsItem'
import { ReactComponent as Bookmark } from '../../../assets/book-mark.svg'
import { ReactComponent as Update } from '../../../assets/update.svg'
import { ReactComponent as EditSvg } from '../../../assets/edit.svg'

import { Brands } from '../../../utils/Brands'
import parseCurrency from '../../../utils/parseCurrency'
import EditWishlistModal from '../../EditWishlistModal'

import {
    CardNameLeft,
    CardNameRight,
    Container,
    WishlistInformationsCard,
    WishlistInformationsCardItems,
    WishlistInformationsCardNameContent,
    WishlistInformationsSettings,
} from './styles'
import SendGTAGEvent from '../../../utils/sendGTAGEvent'

interface ILoadingState {
    infosLoading: boolean;
    itensLoading: boolean;
}

interface IUserWishListInformationsProps {
    name: string;
    cachedAt: Date;
    createdAt: string;
    environment: string;
    totalProducts: number;
    loading: ILoadingState;
    error: boolean;
    pageViews: number;
    sales: number;
    amountSales: number;
    conversionRate: number;
    onClickDeleteButton: () => void;
    onClickEditButton: () => void;
    onClickUpdateButton: (noCache?: boolean) => void;
}

const UserWishlistInformations: React.FC<IUserWishListInformationsProps> = ({
    createdAt,
    environment,
    name,
    totalProducts,
    loading,
    error,
    sales,
    conversionRate,
    pageViews,
    cachedAt,
    onClickDeleteButton,
    onClickEditButton,
    onClickUpdateButton,
    amountSales
}) => {

    const [isOpenEdit, setIsOpenEdit] = useState(false)

    const handledWishlistCreatedDateMemo = useMemo(() => {
        if (!createdAt) return ''

        const wishlistDate = new Date(createdAt)
        const monthName = wishlistDate.toLocaleString('pt-br', { month: "short" })
            .replace('.', '')
            .split('')
            .map((letter, idx) => idx === 0 ? letter.toUpperCase() : letter)
            .join('')

        return `${wishlistDate.getDate()} ${monthName} ${wishlistDate.getFullYear()}`
    }, [createdAt])

    const handledBrandWishlistMemo = useMemo(() => Brands.find((brand) => brand.vtexName === environment)?.name, [environment])

    const onCheckListValue = useCallback((amount: number) => {
        if (amount >= 10) {
            return `${amount}`
        } else {
            return `0${amount}`
        }
    }, [])

    const lastUpdate = (dateCache: Date) => {
        if (!(dateCache instanceof Date && !isNaN(dateCache.getTime()))) {
            return 'há menos de 1 minuto'
        }

        const dateNow = new Date()
        const date = Math.abs(dateNow.getTime() - dateCache.getTime());
        let seconds = Math.floor(date / 1000);
        let minutes = Math.floor(seconds / 60);
        let hours = Math.floor(minutes / 60);

        if (hours <= 0 && minutes <= 0) {
            return 'há menos de 1 minuto'
        } else if (hours > 0) {
            return `há ${hours} hora(s)`
        } else if (hours <= 0) {
            return `há ${minutes} minutos(s)`
        }
    }

    const WishlistInformationsCardItemMemo = [
        { field: 'Criação', value: handledWishlistCreatedDateMemo, loading: loading.itensLoading },
        { field: 'Marca', value: handledBrandWishlistMemo || '', loading: loading.itensLoading },
        { field: 'Qtde. de produtos', value: onCheckListValue(totalProducts) || '', loading: loading.infosLoading },
        { field: 'Visitantes', value: pageViews, loading: loading.infosLoading },
        { field: 'Total de vendas', value: parseCurrency(sales), loading: loading.infosLoading },
        { field: 'Qtde. de vendas', value: amountSales, loading: loading.infosLoading },
        { field: 'Taxa de conversão', value: `${conversionRate.toFixed(2)}%`, loading: loading.infosLoading }
    ]
    return (
        <Container>
            <WishlistInformationsCard>
                {loading.itensLoading ? <h4 className='loadingInfo'>Carregando...</h4> : <WishlistInformationsCardNameContent>
                    <CardNameLeft>
                        <div>
                            <Bookmark />
                            <h4> {name} </h4>
                        </div>
                        <span>Dados atualizados {lastUpdate(cachedAt)}</span>
                    </CardNameLeft>
                    <CardNameRight onClick={() => {
                        onClickUpdateButton(true)
                        SendGTAGEvent(
                            'atualizar_cache_lojinha',
                            'Lojinha',
                            'Clicou em botão "Atualizar',
                        )
                    }}>
                        <Update className='icon_update' />
                        <p>Atualizar</p>
                    </CardNameRight> 
                </WishlistInformationsCardNameContent>}
                {

                    <WishlistInformationsCardItems>
                        {
                            WishlistInformationsCardItemMemo.map((item) => (
                                <UserWishlistInformationItem key={item.field} field={item.field} value={item.value} loading={item.loading} />
                            ))
                        }
                    </WishlistInformationsCardItems>
                }
            </WishlistInformationsCard>

            <WishlistInformationsSettings>
                <button className='btn__edit edit' disabled={loading.infosLoading || error} onClick={() => setIsOpenEdit(!isOpenEdit)} >
                    <EditSvg />
                    editar
                </button>

            </WishlistInformationsSettings>

            <EditWishlistModal
                isOpen={isOpenEdit} onClose={() => setIsOpenEdit(!isOpenEdit)}
                onClickEditButton={onClickEditButton} onClickDeleteButton={onClickDeleteButton} />
        </Container>
    )
}

export default UserWishlistInformations